import { moduleApi } from '~/apis/module'; 
import { createAsyncThunk } from '@reduxjs/toolkit';
import { UpsertModuleWatchProgressBody } from '~/utils/interface/module';

export const upsertModuleWatchProgress = createAsyncThunk(
  'module/upsertWatchProgress',
  async (
    { moduleId, body }: { moduleId: number; body: UpsertModuleWatchProgressBody },
    { rejectWithValue }
  ) => {
    try {
      const res = await moduleApi.upsertModuleWatchProgress(moduleId, body);
      return {
        moduleId,
        body,
        response: res.data,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);